import { createFileRoute } from '@tanstack/react-router'
import { AdminCampaigns } from '@/components/admin/marketing/AdminCampaigns'

export const Route = createFileRoute('/admin/marketing/campaigns')({
  component: () => <AdminCampaigns />,
})
